// NPM Imports
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Components Imports
import AddPbookBtnTnB from "../../../componentsTnb/AddPbookBtnTnB";
import AddPricebookBtn from "../AddPricebookBtn";
import PriceListCard from "./PricelistCard";
import TitleBar from "../../TitleBar";
import { FeatureGating } from "../../../commonComponents";

// Internal Imports
import withRbac from "../../../app/withRbac";
import { PERMISSIONS, FEATURES } from "../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

class PricebookList extends Component {
  render() {
    const AddPricebookBtnRbac = withRbac(() => (
      <FeatureGating
        name={FEATURES_NAME.PRICEBOOK_ADD_PRICEBOOK}
        counterFlag={this.props.pricelists.length}
        altComponent={<AddPbookBtnTnB />}>
        <AddPricebookBtn btnAction={this.props.toggleAddPBPopup} />
      </FeatureGating>
    ));
    return (
      <Fragment>
        <div className="page-topbar">
          <TitleBar
            iconName="book-spells"
            title="Price Books"
            subTitle="This is the place to manage all your priceboooks."
          />
          <div className="create-container" />
        </div>
        <div className="pricebooklist-section">
          <div className="pricebooklist-scrollable">
            <div className="pricebooklist-wrapper">
              {/* <div className="pricebooklist-title">
              <span>PRICELISTS</span>
              <span>CURRENCY</span>
            </div> */}
              {this.props.pricelists.map(list => (
                <Link
                  to={{
                    pathname: `/pricebooks/${list.id}`,
                    state: { selectedPbook: list },
                  }}
                  key={list.id}>
                  <div
                    className={`pricebooklist-card ${
                      list.active ? "pblist-active" : "pblist-inactive"
                    }`}
                    role="button"
                    tabIndex="0">
                    <PriceListCard list={list} toggleView={this._toggleView} />
                  </div>
                </Link>
              ))}

              <AddPricebookBtnRbac
                permission={PERMISSIONS.PRICEBOOKS.CREATE_PRICEBOOKS}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

PricebookList.defaultProps = {};

PricebookList.propTypes = {
  // Props
  pricelists: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // Actions
};

export default PricebookList;
